import { invoiceParamKey, paymentParamKey, Route } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'due_date',
        direction: 'asc',
    })

    await route.addFilter({
        column: 'invoice_payment_status',
        operator: '=',
        value: 'outstanding',
    })

    route.setLimit(1000)
}

export enum CompanyPayRouteName {
    Index = 'company.pay.index',
    EditInvoice = 'company.pay.edit.invoice',
    SendReceipt = 'company.pay.send.receipt',
}

export default {
    path: 'pay',
    name: CompanyPayRouteName.Index,
    component: () => import('@/views/company/pay/Index.vue'),
    meta: {
        label: 'Pay Invoice',
        auth: true,
        permission: Permission.PaymentCreate,
    },
    children: [
        {
            path: `:${invoiceParamKey}/edit`,
            name: CompanyPayRouteName.EditInvoice,
            component: () => import('@/views/company/pay/Index.vue'),
            meta: {
                label: 'Edit Invoice',
                auth: true,
                permission: Permission.InvoiceUpdate,
            },
        },
        {
            path: `:${paymentParamKey}/send`,
            name: CompanyPayRouteName.SendReceipt,
            component: () => import('@/views/company/pay/Index.vue'),
            meta: {
                label: 'Send Receipt',
                auth: true,
                permission: Permission.ReceiptSend,
            },
        },
    ],
}
